import React from 'react';
import { useOrion } from '../context/OrionContext';
import { VIEW_META } from './Topbar';
import Icon from './Icon';

// ─────────────────────────────────────────────────────────────────────────────
// Cabeçalho da área de conteúdo — mesma peça do ContentHeader do Nexus.
//
// A linha miúda em cima (eyebrow) diz o que a tela faz; o título grande, com o
// ícone na cor de acento, diz onde a pessoa está. É o que dá o ritmo das telas
// de lá, e sem ele o conteúdo começa "seco", colado no cabeçalho.
// ─────────────────────────────────────────────────────────────────────────────

export default function ContentHeader({ acoes }) {
  const { view, ehDesktop } = useOrion();
  const meta = VIEW_META[view] || VIEW_META.helpdesk;

  return (
    <>
      <div className="ch-eyebrow">{meta.eyebrow}</div>
      <div className="ch-row">
        <div className="ch-titlewrap">
          <div className="ch-title" style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
            <Icon name={meta.icon} size={22} style={{ color: 'var(--team)' }} />
            {meta.titulo}
          </div>
        </div>
        <div className="ch-actions">
          {acoes}
          <span className="update-chip">
            {ehDesktop ? 'Desktop' : 'Web'} <Icon name="check" size={13} className="ok" />
          </span>
        </div>
      </div>
    </>
  );
}
